import { Table } from "antd";

const format = (v) =>
  `₹${Number(v ?? 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
  })}`;

const SalesReturnGSTR1Table = ({ data = [], printMode = false }) => {
  const columns = [
    {
      title: "Description",
      dataIndex: "label",
      width: "40%",
    },
    {
      title: "IGST Amount",
      dataIndex: "igst",
      align: "right",
      render: format,
    },
    {
      title: "CGST Amount",
      dataIndex: "cgst",
      align: "right",
      render: format,
    },
    {
      title: "SGST Amount",
      dataIndex: "sgst",
      align: "right",
      render: format,
    },
    {
      title: "Taxable Amount",
      dataIndex: "taxable",
      align: "right",
      render: format,
    },
    {
      title: "Invoice Total",
      dataIndex: "total",
      align: "right",
      render: format,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={false}
      bordered
      rowKey="key"
      tableLayout="fixed"
      scroll={printMode ? undefined : { x: 900 }}
    />
  );
};

export default SalesReturnGSTR1Table;